import { render, staticRenderFns } from "./login-precifique-return.view.html?vue&type=template&id=687597a1&"
import script from "./login-precifique-return.vue?vue&type=script&lang=ts&"
export * from "./login-precifique-return.vue?vue&type=script&lang=ts&"
import style0 from "./login-precifique-return.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports